import React, { createContext, useContext } from "react";
import { Pager, PagerProps } from "@progress/kendo-react-data-tools";

interface RefreshPagerContext {
  onRefresh: () => void;
  isFetching: boolean;
}

const RefreshCtx = createContext<RefreshPagerContext>({ onRefresh: () => {}, isFetching: false });

/** Wrap <Grid> with this provider to supply the refresh callback to the custom pager. */
export const RefreshPagerProvider = RefreshCtx.Provider;

/** Custom Kendo pager that appends a refresh button after the page-info text. */
export function RefreshPager(props: PagerProps) {
  const { onRefresh, isFetching } = useContext(RefreshCtx);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Pager {...props} style={{ ...props.style, flex: 1, border: "none" }} />
      <button
        type="button"
        className="btn btn-link btn-sm p-0"
        title="Refresh"
        aria-label="Refresh"
        onClick={onRefresh}
        disabled={isFetching}
        style={{
          marginRight: 12,
          fontSize: "1.1rem",
          lineHeight: 1,
          color: "#656565",
        }}
      >
        <i className="bi bi-arrow-clockwise" aria-hidden="true" />
      </button>
    </div>
  );
}
